/* import __COLOCATED_TEMPLATE__ from './tile.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { Action, MessageUnit, SPOSTileFormat } from '@square/dashboard-protos/models/squareup/messageservice/service';
import { BANKING_HOME_PAGE_PLACEMENT_ID } from '@banking/api/services/message-service-api';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
let BankingTile = (_dec = computed('args.messageUnits.length', 'cursor'), _dec2 = computed('currentMessage.{sposTileFormat,tileFormat}'), _dec3 = computed('args.messageUnits.length'), _dec4 = computed('args.messageUnits.length'), _dec5 = computed('currentTile.imageUrl'), _dec6 = computed('imageUrl'), _class = class BankingTile extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "sentry", _descriptor, this);
    _initializerDefineProperty(this, "messageServiceApi", _descriptor2, this);
    _initializerDefineProperty(this, "cursor", _descriptor3, this);
  }
  get currentMessage() {
    if (this.cursor >= 0 && this.cursor <= this.args.messageUnits.length - 1) {
      const currentMessage = this.args.messageUnits[this.cursor];
      if (currentMessage instanceof MessageUnit) {
        this.trackEngagement(currentMessage, Action.VIEW);
      }
      return currentMessage;
    } else {
      this.sentry.withScope(scope => {
        scope.setLevel('warning');
        this.sentry.captureMessage('Tried to access out of range messageUnit');
      });
      throw new Error('Tried to access out of range messageUnit');
    }
  }
  get currentTile() {
    return this.currentMessage?.tileFormat ?? this.currentMessage?.sposTileFormat;
  }
  get showTile() {
    return this.args.messageUnits?.length > 0;
  }
  get showPagination() {
    return this.args.messageUnits?.length > 1;
  }
  get imageUrl() {
    if (this.currentTile instanceof SPOSTileFormat) {
      return this.currentTile?.imageUrl;
    } else {
      return undefined;
    }
  }
  get showImage() {
    return Boolean(this.imageUrl);
  }
  handleTileClick() {
    this.trackEngagement(this.currentMessage, Action.CLICK);

    // TODO: refactor if there are more actions in the future
    // currently just use clientAction for viewInstantPayoutsDds and fallback to linkUrl for other scenarios
    if (this.currentTile?.clientAction?.viewInstantPayoutsDds && this.args.viewInstantPayoutsDds) {
      this.args.viewInstantPayoutsDds();
    } else if (this.currentTile?.linkUrl) {
      theWindow.open(this.currentTile.linkUrl, '_blank', 'noopener noreferrer');
    }
  }
  trackEngagement(message, action) {
    this.messageServiceApi.trackEngagement(BANKING_HOME_PAGE_PLACEMENT_ID, message.requestToken, action);
  }
  goRight(event) {
    // Parent component is clickable
    event.stopPropagation();

    // Go right infinitely
    if (this.cursor < this.args.messageUnits.length - 1) {
      this.cursor += 1;
    } else {
      this.cursor = 0;
    }
  }
  goLeft(event) {
    // Parent component is clickable
    event.stopPropagation();

    // Go left infinitely
    if (this.cursor > 0) {
      this.cursor -= 1;
    } else {
      this.cursor = this.args.messageUnits.length - 1;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "messageServiceApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cursor", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentMessage", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currentMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTile", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "currentTile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTile", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showTile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPagination", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "showPagination"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showImage", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "showImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTileClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTileClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goRight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goRight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goLeft", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goLeft"), _class.prototype), _class);
export { BankingTile as default };